import { FeaturesState } from '../../../../@types';

const initialState: FeaturesState = [];
export default initialState;
